export default "__VITE_ASSET__CqCZFBAC__"